import React, { createContext, useState, useContext, useEffect } from 'react';
import translations from '../content/translations.json';

const LanguageContext = createContext();

export const LANGUAGES = ['en', 'ro'];
const DEFAULT_LANGUAGE = 'en';
const STORAGE_KEY = 'language';

// Remembers the visitor's choice; crawlers and first-time visitors get English
const getInitialLanguage = () => {
    try {
        const saved = window.localStorage.getItem(STORAGE_KEY);
        if (LANGUAGES.includes(saved)) return saved;
    } catch {
        // Storage can be unavailable (private mode, blocked cookies)
    }
    return DEFAULT_LANGUAGE;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(getInitialLanguage);

    useEffect(() => {
        document.documentElement.lang = language;
        try {
            window.localStorage.setItem(STORAGE_KEY, language);
        } catch {
            // Not critical: the choice just won't be remembered
        }
    }, [language]);

    const t = (key, fallback) => {
        const keys = key.split('.');
        let result = translations[language];
        for (const k of keys) {
            if (result && result[k] !== undefined) {
                result = result[k];
            } else {
                return fallback !== undefined ? fallback : key;
            }
        }
        return typeof result === 'string'
            ? result.replace('{year}', new Date().getFullYear())
            : result;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
